import { React, useEffect, useRef, useState } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Dropzone from "react-dropzone";
import { delImg, uploadImg } from "../features/upload/uploadSlice";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  createBlogs,
  getABlog,
  resetState,
  updateABlog,
} from "../features/blogs/blogSlice";
 
let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  description: yup.string().required("Description is Required"),
  category: yup.string().required("Category is Required"),
});

const Addblog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getBlogId = location.pathname.split("/")[3];
  
  const imgState = useSelector((state) => state.upload.images);
   const blogState = useSelector((state) => state.blogs);
  const isInitialRender = useRef(true);
  const {
    isSuccess,
    isError,
    isLoading,
    createdBlog,
    blogName,
    blogDesc,
    blogCategory,
    blogImages,
    updatedBlog,
  } = blogState;

  const imgIsSuccess = useSelector((state) => state.upload.isSuccess);
  const imgIsError = useSelector((state) => state.upload.isError);
  const isUploading = useSelector((state) => state.upload.isLoading);

  useEffect(() => {
    if (getBlogId !== undefined) {
      dispatch(getABlog(getBlogId));
    } else {
      dispatch(resetState());
    }
  }, [getBlogId]);

 

  const handleImageDelete = (public_id) => {
    const updatedImages = formik.values.images.filter(
      (image) => image.public_id !== public_id
    );
    
    formik.setFieldValue("images", updatedImages);
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false; // Prevent toast on initial fetch
      return;
    }
  
    if (imgIsSuccess && imgState.length > 0) {
      toast.success("Image uploaded successfully!", {
        autoClose: 4000,
      });
      formik.setFieldValue("images", imgState);
    }
  
    if (imgIsError) {
      toast.error("Image upload failed. Please try again.", {
        autoClose: 4000,
      });
    }
  }, [imgIsSuccess, imgIsError, imgState]);

  useEffect(() => {
    if (isSuccess && createdBlog) {
      toast.success("Blog Added Successfully!", { autoClose: 2000 });
  
      setTimeout(() => {
        window.location.href = "/admin/blog-list";
      }, 2000); // Delay navigation until after toast is shown
    }
    
    if (isSuccess && updatedBlog) {
      toast.success("Blog Updated Successfully!", { autoClose: 2000 });
  
      setTimeout(() => {
        window.location.href = "/admin/blog-list";
      }, 2000);
    }
  
    if (isError) {
      toast.error("Something Went Wrong!", { autoClose: 2000 });
    }
  }, [isSuccess, isError, isLoading]);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: blogName || "",
      description: blogDesc || "",
      category: blogCategory || "",
      images:  blogImages || [],
    },
    validationSchema: schema,
    onSubmit: (values) => {
       if (getBlogId !== undefined) {
        dispatch(updateABlog({ id: getBlogId, blogData: values }));
        formik.resetForm({
          values: {
            ...formik.initialValues,
            images: [], 
          },
        });
      } else {
        dispatch(createBlogs(values));
        formik.resetForm({
          values: {
            ...formik.initialValues,
            images: [], // Clear images after submission
          },
        });
      }
      dispatch(resetState());
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getBlogId !== undefined ? "Edit" : "Add"} Blog
      </h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Blog Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
          </div>
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          <select
            name="category"
            onChange={formik.handleChange("category")}
            onBlur={formik.handleBlur("category")}
            value={formik.values.category}
            className="form-control py-3  mt-3"
            id=""
          >
            <option value="">Select Blog Category</option>
            <option value="col-1">Col-1</option>
            <option value="col-2">Col-2</option>
          </select>
          <div className="error">
            {formik.touched.category && formik.errors.category}
          </div>
          <ReactQuill
            theme="snow"
            className="mt-3"
            name="description"
            onChange={formik.handleChange("description")}
            value={formik.values.description}
          />
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>
          <div className="bg-white border-1 p-5 text-center mt-3">
            <Dropzone
              onDrop={(acceptedFiles) => dispatch(uploadImg(acceptedFiles))}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
           <div
        className={`showimages d-flex flex-wrap gap-3 ${
          isUploading ? "loading-border " : ""
        }`}
      >
        {formik.values.images &&
          formik.values.images.map((image, index) => (
            <div className="image-card position-relative" key={index}>
              <button
                type="button"
                onClick={() => handleImageDelete(image.public_id)}
                className="btn-close position-absolute"
                style={{ top: "10px", right: "10px" }}
              ></button>
              <img src={image.url} alt="" width="100%" height={200} />
            </div>
          ))}
      </div>

          

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getBlogId !== undefined ? "Edit" : "Add"} Blog
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addblog;
